import React, { useRef } from "react";
import { Form } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import FilterationBarContainer from "../../../components/FilterationBarContainer";
import { Col } from "reactstrap";
import CustomReactSelect from "../../../components/CustomReactSelect";

const FilterationBar = (props) => {
	const {
		status,
		selectedStatus,
		onStatusChange,
		startDate,
		endDate,
		onStartDateChange,
		onEndDateChange,
	} = props;
	const startDatepickerRef = useRef(null);
	const endDatepickerRef = useRef(null);
	const openStartDatepicker = () => {
		const datepickerElement = startDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	const openEndDatepicker = () => {
		const datepickerElement = endDatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	return (
		<FilterationBarContainer>
			<Col lg={4}>
				<Form.Group className="input-field">
					<Form.Label className="label">Status</Form.Label>
					<Col>
						<CustomReactSelect
							className="ml-0"
							options={status}
							value={selectedStatus}
							onChange={(value) => onStatusChange(value)}
						/>
					</Col>
				</Form.Group>
			</Col>
			<Col lg={4}>
				<Form.Group className="input-field">
					<Form.Label className="label">Start Date</Form.Label>
					<Col className="datepicker-wrapper">
						<DatePicker
							showYearDropdown
							showMonthDropdown
							dateFormatCalendar=" " //for title
							dateFormat="dd/MM/yyyy"
							name="lStartDate"
							className="custom-container"
							onChange={(e) => onStartDateChange(e)}
							selected={startDate}
							autoComplete="off"
							maxDate={new Date()}
							ref={startDatepickerRef}
						/>
						<FontAwesomeIcon
							icon={faCalendarAlt}
							className="calender-icon"
							color="keppel"
							onClick={() => openStartDatepicker()}
						/>
					</Col>
				</Form.Group>
			</Col>
			<Col lg={4}>
				<Form.Group className="input-field">
					<Form.Label className="label">End Date</Form.Label>
					<Col className="datepicker-wrapper">
						<DatePicker
							showYearDropdown
							showMonthDropdown
							dateFormatCalendar=" " //for title
							dateFormat="dd/MM/yyyy"
							className="custom-container"
							selected={endDate}
							onChange={(e) => onEndDateChange(e)}
							name="lEndDate"
							minDate={startDate}
							maxDate={new Date()}
							autoComplete="off"
							ref={endDatepickerRef}
						/>
						<FontAwesomeIcon
							icon={faCalendarAlt}
							className="calender-icon"
							color="keppel"
							onClick={() => openEndDatepicker()}
						/>
					</Col>
				</Form.Group>
			</Col>
		</FilterationBarContainer>
	);
};

export default FilterationBar;
